export default {
  "remove": "Remove",
  "save": "Save",
  "open": "Open",
  "edit": "Edit",
  "cancel": "Cancel",
  "search.placeholder": "Search ...",

  "codelist": {
    "title": "Codelists",
    "add": "Add Data",
    "list": {
      "key": "Key",
      "value": "Value",
      "updated": "Updated",
      "created_at": "Created",
      "data": "Value",
      "title": "Title",
      "color": "Color",
      "icon": "Icon",
      "additional_fields_schema": "Schema",
      "hg_ug_id": "HgUg code",
      "ics_categories": "Ics Categories",
      "ics_category_hgug_codes": "HgUg Codes",
      "country_id": "Country",
      "date": "Date"
    },
    "category": {
      "title": "Categories",
      "list": {
        "title": "Title",
        "define.schema": "Define schema",
        "define.schema.desc": "Does individual entry in the list contain multiple values",
        "schema": "Schema",
        "remove": "Remove Category",
        "edit": "Edit Category",
        "new": "New Category",
        "save": "Save Category",
        "add": "Add Category"
      },
      "one.document": "document",
      "two.documents": "documents",
      "3-4.documents": "documents",
      "many.documents": "documents",
      "msg": {
        "remove": "Are you sure you want to remove category",
        "wrong.schema": "Data schema is wrong",
        "saved": "Category successfully saved",
        "empty": "Codelists are empty. Create your first category and start adding data"
      }
    },
    "msg": {
      "removed": "Data was succesfully removed.",
      "updated": "Data updated",
      "remove.error": "An error occured while removing data"
    }
  },
  "msg": {
    "save.error": "An error occured while removing category"
  },
  "document": {
    "category": {
      "rating-center": "Ocenjevalni center",
      "rating-center/candidate": "Ocenjevalni center - Kandidat",
      "company": "Podjetje",
      "candidate": "Kandidat",
      "user-portal/download": "Uporabniški portal - Prenos",
      "cover": "Cover stran"
    }
  },
  "measure": {
    "ContentTree": {
      "title": "Organigram podjetja",
      "description": "Struktura oddelkov in seznam zaposlenih v podjetju",
      "units": "Oddelki",
      "employees": "Zaposleni",
      "content": "Vsebina",
      "edit": "Uredi",
      "import_data": "Uvoz podatkov",
      "download_structure": "Prenos strukture",
      "new_subnode": "Podkategorija",
      "delete": "Izbriši",
      "close": "Zaključi urejanje"
    }
  },
  "UIK": {
    "components": {
      "universal": {
        "table": {
          "paginate": {
            "next": "Naprej",
            "previous": "Nazaj"
          }
        }
      }
    }
  }
}
